(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('ProfessionalAreaGroupController', ProfessionalAreaGroupController);

    ProfessionalAreaGroupController.$inject = ['ProfessionalAreaGroup', 'ProfessionalAreaGroupSearch'];

    function ProfessionalAreaGroupController(ProfessionalAreaGroup, ProfessionalAreaGroupSearch) {

        var vm = this;

        vm.professionalAreaGroups = [];
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            ProfessionalAreaGroup.query(function(result) {
                vm.professionalAreaGroups = result;
                vm.searchQuery = null;
            });
        }

        function search() {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            ProfessionalAreaGroupSearch.query({query: vm.searchQuery}, function(result) {
                vm.professionalAreaGroups = result;
                vm.currentSearch = vm.searchQuery;
            });
        }

        function clear() {
            vm.searchQuery = null;
            loadAll();
        }    }
})();
